export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_7-1559751d9f869d7f3c389d47f050a454.jpg";